<div [ngStyle]="{
    'display': 'inline-block',
    'min-width': '300px',
    'max-width': width  
  }">
    <app-dynamic-table [schema]="schema" [modalfieldConfig]="fieldConfig" [total]="total" [data]="list" (changeEvent)="change($event)" (actionEvent)="formEvent($event)"></app-dynamic-table>
</div>

